import { useEffect } from "react"
import { Outlet, useParams, useNavigate, useOutletContext } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"

import Spinner from 'react-bootstrap/Spinner'

import { NotificationTypes, addNotification } from "../../stores/notification-store.js"
import UtgNotMigratedWarning from "./components/UtgNotMigratedWarning.jsx";
import useComponentConfigSchema, { componentConfigSchema } from "../../hooks/useComponentConfigSchema.js"
import useUtgData from "../../hooks/useUtgData";

export default function Utg() {    

    const navigate = useNavigate()
    const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData, permissionMasks, permissions  } = useOutletContext()
    const { beId, componentId } = useParams()
    const { utg, loading, error } = useUtgData(beId, componentId, config, accessToken)
    const { loading: componentConfigSchemaLoading, isMigrated } = useComponentConfigSchema(beId, utg.value.UtgVersion, config, accessToken)

    useEffect(() => {
        if (userPermissionsSummary.value && !userPermissionsSummary.value.canViewUtgs) {
            addNotification('You are not authorized to view UTGs for this account.', NotificationTypes.ERROR, true)
            navigate(`/`)
        }
    }, [userPermissionsSummary.value])
    
    const canEditSignal = useComputed(() => {
        return userPermissionsSummary?.value?.canEditUtgs
    })

    if (loading.value || componentConfigSchemaLoading.value) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner className="mt-5 align-center" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <>
        <UtgNotMigratedWarning showWarning={!isMigrated.value} />
        <Outlet context={{ config, accessToken, user, userPermissions, userPermissionsSummary, canEditSignal, sidebarAccordionData }} />
        </>
    )
}